import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const EQUIPMENTS_EQUIPMENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/equipments',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:Equipments',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.Equipments',
      },
    ]);
  };
}
